import { useTranslation } from 'react-i18next'
import { Input, EmptyIcon, EmptyContent, EmptyText } from '../_styles'

const Empty = ({ onChange, multiple }) => {
  const { t } = useTranslation()

  const handleChange = event => {
    if (multiple && event.target.files.length > 0) {
      onChange(event.target.files)
    } else if (event.target.files[0]) {
      onChange(event.target.files[0])
    }
  }

  return (
    <>
      <EmptyContent>
        <EmptyIcon width='32' height='32' viewBox='0 0 32 32' fill='none'>
          <circle cx='16' cy='16' r='16' />
          <path d='M16 9.30974C16.413 9.30974 16.7475 9.64426 16.7475 10.0572L16.7475 15.0407L21.731 15.0407C22.144 15.0407 22.4785 15.3752 22.4785 15.7882C22.4785 16.2012 22.144 16.5357 21.731 16.5357L16.7475 16.5357L16.7475 21.5192C16.7475 21.9322 16.413 22.2667 16 22.2667C15.587 22.2667 15.2525 21.9322 15.2525 21.5192L15.2525 16.5357L10.269 16.5357C9.85603 16.5357 9.52152 16.2012 9.52152 15.7882C9.52152 15.3752 9.85603 15.0407 10.269 15.0407L15.2525 15.0407L15.2525 10.0572C15.2525 9.64426 15.587 9.30974 16 9.30974Z' />
        </EmptyIcon>

        <EmptyText>{t('review.upload.text')}</EmptyText>
      </EmptyContent>

      <Input
        type='file'
        multiple={multiple}
        accept='.jpeg, .jpg, .png, .svg, .webp, .heic'
        onChange={handleChange}
        onClick={event => (event.target.value = null)}
      />
    </>
  )
}

export default Empty
